import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import { CareItem } from 'src/replicant/buruburu/care/care.ruleset';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver from 'src/StateObserver';
import { parseAmount } from 'src/lib/utils';
import uiConfig from 'src/lib/ui/config';

const ui = uiConfig.buruburu.care.itemButton;

type CareItemButtonOpts = Pick<ButtonScaleViewOpts, 'onClick'> & {
  careItem: CareItem;
};
export default class CareItemButton extends ButtonScaleView {
  constructor({ careItem, onClick }: CareItemButtonOpts) {
    super({
      ...ui.container,
      onClick,
      tracking: { feature: 'care-item', $subFeature: careItem.id },
    });

    // icon
    this.addSubview(
      new ImageScaleView({
        ...ui.image,
        image: ui.icons[careItem.id],
      }),
    );

    // name
    this.addSubview(
      new LangBitmapFontTextView({
        ...ui.name,
        localeText: () => careItem[`name_${getLocaleSuffix()}`],
        wordWrap: StateObserver.getState().ui.locale === 'en',
      }),
    );

    // price
    this.addSubview(
      new LangBitmapFontTextView({
        ...ui.price,
        localeText: () => parseAmount(careItem.price),
      }),
    );

    // currency icon
    this.addSubview(new ImageScaleView(ui.currency));
  }
}

const getLocaleSuffix = () =>
  StateObserver.getState().ui.locale === 'en' ? 'en' : 'jp';
